import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calendar } from 'lucide-react';

const MobileBookBar = () => {
  const location = useLocation();
  const hidden = ['/admin', '/book', '/login', '/register', '/payment'].some((p) =>
    location.pathname.startsWith(p),
  );
  if (hidden) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#04140e]/95 backdrop-blur-sm border-t border-[#c5a059]/40 p-3 shadow-2xl"
      data-testid="mobile-book-bar"
    >
      <Link to="/services" className="block">
        <button className="w-full bg-[#c5a059] text-[#04140e] font-semibold py-3 rounded-full flex items-center justify-center gap-2 hover:bg-[#d4b56e] transition-colors">
          <Calendar className="w-4 h-4" />
          Book Appointment
        </button>
      </Link>
    </div>
  );
};

export default MobileBookBar;
